import { Edit } from '@mui/icons-material';
import { IconButtonProps } from '@mui/material';
import * as i18next from 'i18next';
import React from 'react';

import { MutationIconButton } from '@/components/buttons/mutation-button';

interface Properties extends IconButtonProps {
  item: unknown;
  t: i18next.TFunction;
  onEdit: (value: any) => void;
  id?: string;
}

const EditButton: React.FC<Properties> = (props) => {
  const { item, t, onEdit, id, ...rest } = props;

  return (
    <MutationIconButton
      id={id}
      tooltipMsg={t(['shared:edit'], { defaultValue: 'Edit' })}
      onClick={() => onEdit(item)}
      {...rest}
    >
      <Edit />
    </MutationIconButton>
  );
};

export default EditButton;
